'use strict';

const { h } = require('preact');

const PriceLabel = ({
  isMovieDeal,
  option: {
    pricing: { pricingLabel },
  },
  showPriceLabel,
}) => {
  if (!pricingLabel || !showPriceLabel) {
    return null;
  }
  let classes = 'price-label';

  if (isMovieDeal) {
    classes += ' movie-price-label';
  }

  return h('span', { class: classes }, pricingLabel);
};

module.exports = PriceLabel;
